const palette = {
    primary: {
        main: "#001EFF",
        dark: "#0018CC"
    },
    secondary: {},
    error: {},
    warning: {},
    info: {},
    success: {},
    mo: {
        charcoal: "#151515"
    }
};

export default palette;